import { useEffect, useState } from "react";

const navItems = [
  { label: "封面", href: "#top" },
  { label: "栏目合集", href: "#collection" },
  { label: "专题精选", href: "#feature" },
  { label: "官方渠道", href: "#channels" },
  { label: "商务合作", href: "#business" },
  { label: "联系客服", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        {/* brand */}
        <a href="#top" className="group flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-newspaper-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              吃瓜官网
            </span>
            <span className="text-[11px] tracking-widest text-foreground-500">CHIGUA OFFICIAL</span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#contact"
            className="rounded-md border border-foreground-200 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            商务洽谈
          </a>
          <a
            href="#channels"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            官方客服
          </a>
        </div>

        {/* mobile toggle */}
        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
        </button>
      </div>

      {/* mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex w-full max-w-6xl flex-col px-4 py-3 md:px-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <div className="mt-2 flex gap-3 px-2 pb-2">
              <a
                href="#business"
                className="flex-1 rounded-md border border-foreground-200 px-4 py-2.5 text-center text-sm font-medium text-foreground-800"
              >
                商务洽谈
              </a>
              <a
                href="#channels"
                className="flex-1 rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
              >
                官方客服
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}